import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Form, Select } from 'antd';

const ZeroAdjust = (props) => {
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache, translationCache]);

  const translation = (keyword) => {
    return props.translationCache && props.translationCache[keyword] ? props.translationCache[keyword] : keyword;
  };

  const formItemLayout = {
    labelCol: {
      span: 4
    },
    wrapperCol: {
      span: 14
    }
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 14,
      offset: 4
    }
  };

  return (
    <div>
      <Form
        {...formItemLayout}
        layout="horizontal"
        name="HeaderNumber_current"
      >
        <Form.Item label={translation('HD')}>
          <Select style={{ width: 220 }}>
            <Select.Option value="01">01</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label={translation('X1')}>
          <div>0.6656</div>
        </Form.Item>
        <Form.Item label={translation('X2')}>
          <div>0.3944</div>
        </Form.Item>
        <Form.Item {...buttonItemLayout}>
          <Button type="primary">{translation('Zero Adjust')}</Button>
        </Form.Item>

        <Alert
          message={translation('Note:')}
          description={translation('Click The Zero Adjust After Attaching The Zero')}
          type="warning"
        />
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(ZeroAdjust);
